import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

const GlassCard = ({ 
  children, 
  className, 
  hover = true,
  glow = false,
  ...props 
}) => {
  return (
    <motion.div
      whileHover={hover ? { scale: 1.01, y: -2 } : undefined}
      transition={{ duration: 0.2 }}
      className={cn(
        "glass-card p-6 transition-colors duration-300",
        hover && "hover:border-violet-500/30",
        glow && "glow-violet",
        className
      )}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default GlassCard;
